import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

// import DataProtected from "../../assets/images/security/DataProtected.png";
// import SSL from "../../assets/images/security/SSL.png";
// import Clear from "../../assets/images/security/Clear.png";

import { useDispatch } from "react-redux";
import { addContact } from "../../redux/apiCalls";
import { useNavigate, useLocation } from "react-router-dom";

import { RatesFee } from "../popups/RatesFee/RatesFee";
import { SecuritySeal } from "../SecuritySeal/SecuritySeal";
import {
  Box
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

import "./Banner.scss";
import {
  btnSubmitCustom
} from "./style";
import { handleLastStep } from "../../utils/functions";
import { sendDataBrevo } from "../../utils/callApi";
import { LoadingFull } from "../LoadingFull/LoadingFull";

const Banner = () => {
  const isMobile = window.innerWidth < 768;

  const [openRateFee, setOpenRateFee] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  const jornayaRef = useRef(null);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const emailFromURL = searchParams.get("email");
  const loanReasonFromURL = searchParams.get("loan_reason");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // set sessionStorage
  loanReasonFromURL &&
    sessionStorage.setItem("loanReasonFromURL", loanReasonFromURL);

  useEffect(() => {
    const fetchData = async () => {
      if (emailFromURL && loanReasonFromURL) {
        setShowLoading(true);
        try {
          // Dispatch data to Redux
          const res = await addContact(dispatch, {
            email: emailFromURL,
            loanReason: loanReasonFromURL,
            userAgent: navigator.userAgent
          });
          // Send data to email phonexa
          sendDataBrevo(emailFromURL, "", "", [47], loanReasonFromURL);
          // check last step and navigator to next page
          const lastStep = handleLastStep(res?.contact);
          setShowLoading(false);
          lastStep && navigate(`/${lastStep}`);
        } catch (error) {
          setShowLoading(false);
          console.error("Error processing data:", error);
        }
      }
    };
    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailFromURL, loanReasonFromURL]);

  // jornaya lead id - not used in banner anymore, moved to lgname page
  useEffect(() => {
    return () => {
    };
  }, []);

  const handleGetStarted = () => {
    navigate("/lgname");
  };

  return (
    <>
      {showLoading && <LoadingFull />}
      <div className="banner" id="banner">
        {openRateFee && (
          <RatesFee openRateFee={openRateFee} setOpenRateFee={setOpenRateFee} />
        )}
        <div className="container">
          <Box
            className="banner-box"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: isMobile ? "0" : "40px",
              flexDirection: isMobile ? "column" : "row"
            }}
          >
            <Box
              sx={{
                flex: 1,
                maxWidth: isMobile ? "309px" : "auto",
                textAlign: "center",
                position: "relative",
                zIndex: "1"
              }}
            ></Box>
            <Box
              sx={{
                flex: 1,
                padding: isMobile ? "19px 14px 20px" : "19px 47px 20px",
                background: "#FFF",
                borderRadius: "4px"
              }}
            >
              <h2 className="title">
                Get Fast and Reliable Loans up to $5,000
              </h2>
              
              {/* jornaya */}
              <input
                ref={jornayaRef}
                id="leadid_token"
                name="universal_leadid"
                type="hidden"
                value=""
              />

              <p className="tcpa" style={{ marginBottom: "20px" }}>
                By clicking <b>'Get Started'</b>, you agree to our{" "}
                <Link target="_blank" to="/privacy">Privacy Policy</Link>,{" "}
                <Link target="_blank" to="/terms-of-use">Terms</Link>
                {", "}
                <Link onClick={() => setOpenRateFee(!openRateFee)}>
                  Rate & Fees
                </Link>{" "}
                and receive special offers from us and our marketing partners
                via email communication
              </p>
              
              <LoadingButton
                endIcon={<></>}
                loading={false}
                loadingPosition="end"
                variant="contained"
                size="large"
                style={btnSubmitCustom}
                onClick={handleGetStarted}
                type="button"
              >
                <span>GET STARTED</span>
              </LoadingButton>

              <SecuritySeal />
              
            </Box>
          </Box>
        </div>
      </div>
    </>
  );
};

export default Banner;
